/** 이미지 가로, 세로 사이즈 비교 후 상위 요소에 클래스 추가 */
export const handleCheckImgSize = (e) => {
    const targetImg = e.target;
    targetImg.offsetHeight > targetImg.offsetWidth ? targetImg.parentNode.parentNode.classList.add('vertical') : targetImg.parentNode.parentNode.classList.add('horizon');
}